var _circle, _circle2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgInfo = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 11,
  fill: "none",
  stroke: "#266992",
  strokeWidth: 2,
  opacity: 0.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 9,
  fill: "#004F71"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 15,
  width: 2,
  height: 6,
  rx: 1,
  ry: 1,
  fill: "#FFF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 11,
  width: 2,
  height: 2,
  rx: 1,
  ry: 1,
  fill: "#FFF"
})));
export default SvgInfo;